import {cs}                        from "@Common/react/chain-services";
import {consumeContext}            from "@Common/react/context";

import {AGENT_LEVEL, BRANCH_LEVEL} from "@Xpresso/routes/common/logic/user-level";

import {AccountTabsLayout}         from "../../common/account-tabs-layout/account-tabs-layout";

export const OrdersLayout = ({activeTab, next}) => cs(
    consumeContext("accountMenu"),
    consumeContext("userLevels"),
    ["menu", ({userLevels}, next) => next(userLevels.userLevel === AGENT_LEVEL ? "orders" : userLevels.userLevel === BRANCH_LEVEL ? "branchOrders" : "companyOrders")],
    ({accountMenu, menu}, next) => AccountTabsLayout({
        activeMenu: menu,
        activeTab,
        config: accountMenu?.[menu + "Menu"]?.subMenu ?? items,
        next,
    }),
    () => next(),
);

const items = [
    {
        linkLabel: "Pending Orders",
        name: "pending",
        link: "/account/orders/pending",
    },
    {
        linkLabel: "Order History",
        name: "history",
        link: "/account/orders/history",
    },
    {
        linkLabel: "Approval Dashboard",
        name: "approval",
        link: "/account/orders/approval",
    },
    {
        linkLabel: "Scheduled Orders",
        name: "scheduled",
        link: "/account/orders/scheduled",
    },
];